<div class="flex flex-row mx-auto pt-16 items-center justify-center error">
  <mat-card class="flex flex-col bg-accent-50 shadow-md rounded-xl px-10 py-8 items-center gap-6 w-full max-w-xl">
    <!-- Header -->
    <div class="flex gap-4 items-start w-full px-6">
      <mat-icon class="shrink-0 w-7 h-7 mt-1 text-error!">warning</mat-icon>
      <header>
        <h2 class="text-2xl font-semibold" style="color: var(--color-error)">
          {{ 'not_authorized.title' | translate }}
        </h2>
        <p class="text-base mt-2" style="color: var(--color-error)">
          {{ 'not_authorized.sub_title' | translate }}
        </p>
      </header>
    </div>

    <!-- Info Box -->
    <div class="bg-accent-lighter rounded-lg p-6 w-full">
      <div class="flex gap-4">
        <mat-icon class="shrink-0 w-7 h-7 text-accent-600 mt-1">info</mat-icon>
        <div class="text-base text-accent-800 leading-relaxed">
          <p class="font-semibold mb-3">
            {{ 'not_authorized.what_to_do' | translate }}
          </p>
          <ul class="list-disc pl-5 space-y-2 text-accent-700">
            @if (contactEmail()) {
              <li>{{ 'not_authorized.steps.contact_before' | translate }}<a class="underline" [href]="'mailto:' + contactEmail()">{{ contactEmail() }}</a>{{ 'not_authorized.steps.contact_after' | translate }}</li>
            } @else {
              <li>{{ 'not_authorized.steps.contact_admin' | translate }}</li>
            }
            <li>{{ 'not_authorized.steps.request_access' | translate }}</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Actions -->
    <div class="w-full">
      <button (click)="logout()" matButton="outlined" class="w-full flex items-center justify-center gap-2 py-4 text-lg font-medium rounded-lg">
        <mat-icon class="text-xl">logout</mat-icon>
        Logout
      </button>
    </div>
  </mat-card>
</div>
